import { FilterTableIcon } from '@redis-ui/icons';
import * as S from './SvgFilterIcon.style';

interface SvgFilterIconProps {
  isFilterActive: boolean;
}

const SvgFilterIcon = ({ isFilterActive }: SvgFilterIconProps) => {
  return (
    <S.IconButton size="M" color="primary600" icon={FilterTableIcon} $active={isFilterActive} />
  );
};

export default SvgFilterIcon;
